import { StoreItem } from '@site-builder/common/src/types/store';

import { isCustomAuth } from '../../experiments/partnersRequests/utils';
import { UniversalCart } from '../../scripts/blocks/store/cart/UniversalCart';
import { StoreAPIDataService } from '../../scripts/blocks/store/services/StoreAPIDataService';
import { toggleElement } from '../../scripts/helpers/common';

export const updateHidingButtons = ({
  addToCartButton,
  cartSelectButton,
  buyButton,
  checkoutButton,
  cart,
  sku,
  storeAPIDataService,
}: {
  addToCartButton: Element | null;
  cartSelectButton?: Element | null;
  buyButton: Element;
  checkoutButton: Element | null;
  cart: UniversalCart;
  sku: string;
  storeAPIDataService: StoreAPIDataService;
}): void => {
  const foundItem = storeAPIDataService.findBySku(sku) as StoreItem;
  if (!foundItem) {
    throw new Error(
      `Store item was not found in the list received when updating the cart ; SKU – ${sku}`
    );
  }

  const showButton = !cart.hasSKU(foundItem.sku);

  if (addToCartButton) {
    toggleElement(addToCartButton, () => showButton);
  }
  toggleElement(buyButton, () => isCustomAuth() || showButton);
  if (isCustomAuth() && cartSelectButton) {
    toggleElement(cartSelectButton, () => !showButton);
  } else {
    toggleElement(checkoutButton, () => !showButton);
  }
};
